export default __webpack_public_path__ + "static/InnsideAvSkipet-ac7a61add4fee2d15e9aac6ad9c35a9d.jpg";